import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { Button } from '@mantine/core'
import { IoCheckmark, IoHeartOutline } from 'react-icons/io5'
import { useHistory } from 'react-router-dom'
import { useStore } from '../../app/stores/store'

interface Props {
  firearmModelId: string;
}

export default observer(function AddToWishlistButton ({ firearmModelId }: Props) {
  const { wishlistStore, userStore } = useStore()
  const history = useHistory()
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    if (userStore.isLoggedIn && wishlistStore.items.length === 0 && !wishlistStore.loading) {
      wishlistStore.loadWishlist()
    }
  }, [userStore.isLoggedIn, wishlistStore])

  if (!userStore.isLoggedIn) {
    return (
      <Button
        size="sm"
        variant="outline"
        color="gray"
        leftIcon={<IoHeartOutline size={14} />}
        onClick={() => history.push('/register')}
        sx={{ minWidth: 130 }}
      >
        Wishlist
      </Button>
    )
  }

  const inWishlist = wishlistStore.isInWishlist(firearmModelId)
  const item = wishlistStore.getItem(firearmModelId)

  const handleClick = async () => {
    if (inWishlist && item) {
      setBusy(true)
      try {
        await wishlistStore.removeFromWishlist(item.id)
      } finally {
        setBusy(false)
      }
    } else {
      setBusy(true)
      try {
        await wishlistStore.addToWishlist(firearmModelId)
      } finally {
        setBusy(false)
      }
    }
  }

  return (
    <Button
      size="sm"
      variant={inWishlist ? 'light' : 'outline'}
      color={inWishlist ? 'pink' : 'gray'}
      leftIcon={inWishlist ? <IoCheckmark size={14} /> : <IoHeartOutline size={14} />}
      loading={busy}
      onClick={handleClick}
      sx={{ minWidth: 130 }}
    >
      {inWishlist ? 'Wishlisted ♥' : 'Add to Wishlist'}
    </Button>
  )
})
